/*eslint-disable */
const $ = window.jQuery = require('jquery');
export default {
  name: 'mobile-menu-bar',
  components: {},
  props: ['notificationBadgeINFO'],
  data () {
    return {
      mobileMenuBaar:false,
      subMblMenuState:'home',
      isMobile: false,
      notificationBadgeInfo:null,
      is_superuser:Boolean,
      is_admin:Boolean,
      userRoleType:'',
    }
  },
  computed: {
  },
  mounted () {
    this.notificationBadgeInfo = this.notificationBadgeINFO;
    this.$store.dispatch('getAcUserDetailsFun').then((res)=>{
      this.is_superuser = res.data.data.is_superuser;
      this.userRoleType = res.data.data.user_type;
      this.is_admin = res.data.data.is_admin;
    })
  },
  methods: {
    menuBarOpenMehtod(){
      this.mobileMenuBaar = true;
      document.body.classList.add('body_right_scroll_remove');
    },
    menuBarClosedMehtod(){
      this.mobileMenuBaar = false;
      this.subMblMenuState = 'home';
      document.body.classList.remove('body_right_scroll_remove');
    },
    subMblMenuMethod(data){
      this.subMblMenuState = data;
    },
    subMblMenuClosedMethod(){
      this.subMblMenuState = '';
    },
    logOutUser() {
      if ('BroadcastChannel' in self) {
        authChannel.postMessage({
          cmd: 'logout'
        })
      }
    },
    logout(){
      this.$store.dispatch('logout')
      .then(() => {
        this.logOutUser();
        window.location.href = '/';
      })
    },
  } 
}